/* Mobile CTA fixes — dev theme "Mobile CTA Fix (dev)"
   - Fix 2: turns the product buy group into a bottom bar once it scrolls
     out of view (mobile only), with a spacer so content does not jump.
   - Fix 1 hardening: keeps the Transcy widget clickable above the bar and
     out of the top CTA zone by repositioning its fixed root on mobile.
   - Hides the bar while the MCZR/Kickflip customization modal is open. */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 749px)';
  var mq = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
  var inited = false;

  var bar = null;
  var spacer = null;
  var transcyEl = null;
  var io = null;

  function findTranscyWidget() {
    var els = document.querySelectorAll('[class*="transcy"], [id*="transcy"]');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]);
      if (cs.position === 'fixed' && parseInt(cs.zIndex, 10) > 1000) {
        return els[i];
      }
    }
    return null;
  }

  function positionTranscy() {
    if (!transcyEl) return;
    var barVisible = bar && document.body.classList.contains('show-mobile-buy-bar') && !document.body.classList.contains('mczr-modal-open');
    var offset = (barVisible && bar.offsetHeight) ? bar.offsetHeight + 12 : 12;
    transcyEl.style.top = 'auto';
    transcyEl.style.left = 'auto';
    transcyEl.style.right = '0.8rem';
    transcyEl.style.bottom = offset + 'px';
    transcyEl.style.zIndex = '90';
  }

  function observe(el) {
    if (io) io.disconnect();
    if (el) io.observe(el);
  }

  function cleanup() {
    if (io) { io.disconnect(); io = null; }
    document.body.classList.remove('show-mobile-buy-bar', 'mczr-modal-open');
    if (spacer) { spacer.remove(); spacer = null; }
    if (transcyEl) {
      transcyEl.style.top = '';
      transcyEl.style.left = '';
      transcyEl.style.right = '';
      transcyEl.style.bottom = '';
      transcyEl.style.zIndex = '';
      transcyEl = null;
    }
    inited = false;
  }

  function init() {
    if (inited || !mq || !mq.matches) return;
    inited = true;

    bar = document.querySelector('.product-buy-sticky');

    io = new IntersectionObserver(function (entries) {
      var intersecting = entries[0].isIntersecting;
      var isFixed = document.body.classList.contains('show-mobile-buy-bar');

      if (!intersecting && !isFixed && bar) {
        spacer = document.createElement('div');
        spacer.className = 'product-buy-sticky-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        spacer.style.height = (bar.offsetHeight + 30) + 'px';
        bar.insertAdjacentElement('afterend', spacer);
        document.body.classList.add('show-mobile-buy-bar');
        observe(spacer);
        positionTranscy();
      } else if (intersecting && isFixed) {
        document.body.classList.remove('show-mobile-buy-bar');
        if (spacer) { spacer.remove(); spacer = null; }
        observe(bar);
        positionTranscy();
      }
    }, { threshold: 0 });

    function watchTranscy() {
      if (!transcyEl) transcyEl = findTranscyWidget();
      if (transcyEl) positionTranscy();
    }

    watchTranscy();
    setTimeout(watchTranscy, 1000);
    setTimeout(watchTranscy, 3000);

    var bodyObserver = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          if (added[n].nodeType === 1 && String(added[n].className || '').indexOf('transcy') !== -1) {
            watchTranscy();
            return;
          }
        }
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });

    var overlay = document.getElementById('modal-product-mczr-dark-overlay');
    var container = document.getElementById('product-mczr-modal-container');

    function syncModal() {
      var open = !!(overlay && window.getComputedStyle(overlay).display !== 'none') ||
                 !!(container && window.getComputedStyle(container).visibility === 'visible');
      document.body.classList.toggle('mczr-modal-open', open);
      positionTranscy();
    }

    if (overlay || container) {
      syncModal();
      var modalObserver = new MutationObserver(syncModal);
      if (overlay) modalObserver.observe(overlay, { attributes: true, attributeFilter: ['style', 'class'] });
      if (container) modalObserver.observe(container, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    observe(bar);
  }

  if (mq) {
    if (mq.matches) init();
    var onChange = function (e) {
      if (e.matches) {
        cleanup();
        init();
      } else {
        cleanup();
      }
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();
